import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-032d6633"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "outBox"
};
const _hoisted_2 = {
  class: "activity-detail-box medium-detail-box"
};
const _hoisted_3 = {
  class: "activity-info-box small-info-box"
};
const _hoisted_4 = {
  class: "activity-left-info-plan"
};
const _hoisted_5 = {
  style: {
    "background": "white",
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_6 = {
  class: "detail-plan-inset"
};
const _hoisted_7 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "padding": "0 30px",
    "height": "calc(100% - 280px)"
  }
};
const _hoisted_8 = {
  style: {
    "margin": "10px 0",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "cursor": "pointer"
  }
};
const _hoisted_9 = {
  style: {
    "font-size": "36px",
    "font-family": "'NIKE_FUTURA_CN-XB'",
    "word-break": "break-all"
  }
};
const _hoisted_10 = {
  class: "content-label",
  style: {
    "font-size": "18px",
    "color": "#777"
  }
};
const _hoisted_11 = {
  class: "activityTags"
};
const _hoisted_12 = {
  class: "noteBox"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, "Notes:", -1));
const _hoisted_14 = {
  class: "right"
};
const _hoisted_15 = {
  style: {
    "flex": "1",
    "overflow-y": "scroll",
    "padding": "0 30px"
  }
};
const _hoisted_16 = {
  class: "content-title"
};
const _hoisted_17 = {
  style: {
    "width": "40%"
  }
};
const _hoisted_18 = {
  style: {
    "width": "20%"
  }
};
const _hoisted_19 = {
  style: {
    "width": "40%",
    "text-align": "right"
  }
};
const _hoisted_20 = {
  key: 0
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  style: {
    "width": "40%"
  }
};
const _hoisted_23 = {
  style: {
    "width": "20%",
    "color": "#0042ff",
    "cursor": "pointer"
  }
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "40%"
  }
}, null, -1));
const _hoisted_25 = {
  class: "activity-center-info-plan"
};
const _hoisted_26 = {
  style: {
    "padding": "0 25px",
    "background": "white",
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_27 = {
  key: 1,
  class: "pane-area-box",
  style: {
    "width": "100%",
    "height": "200px",
    "flex-shrink": "0"
  }
};
const _hoisted_28 = {
  key: 0,
  class: "up-download-box"
};
const _hoisted_29 = {
  class: "activity-upload-list-box"
};
const _hoisted_30 = {
  class: "activity-list-box"
};
const _hoisted_31 = {
  class: "nowrap-ellipsis up-download-title"
};
const _hoisted_32 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center"
  }
};
const _hoisted_33 = {
  style: {
    "width": "100%",
    "text-align": "center",
    "margin-top": "19px"
  }
};
const _hoisted_34 = {
  class: "upload-box"
};
const _hoisted_35 = {
  class: "upload-box-title"
};
const _hoisted_36 = {
  class: "upload-box-title-text"
};
const _hoisted_37 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_38 = {
  class: "upload-box-dashed"
};
const _hoisted_39 = {
  class: "upload-icon-group-box"
};
const _hoisted_40 = {
  class: "el-upload__text"
};
const _hoisted_41 = {
  style: {
    "font-size": "12px"
  }
};
const _hoisted_42 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "600px",
    "height": "300px",
    "background": "white",
    "overflow-y": "scroll"
  }
};
const _hoisted_43 = {
  style: {
    "width": "40%",
    "text-align": "right"
  }
};
const _hoisted_44 = {
  key: 1,
  class: "up-download-box"
};
const _hoisted_45 = {
  class: "activity-upload-list-box"
};
const _hoisted_46 = {
  class: "activity-list-box"
};
const _hoisted_47 = {
  class: "up-download-title"
};
const _hoisted_48 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center"
  }
};
const _hoisted_49 = {
  style: {
    "width": "100%",
    "text-align": "center",
    "margin-top": "19px"
  }
};
const _hoisted_50 = {
  class: "upload-box"
};
const _hoisted_51 = {
  class: "upload-box-title"
};
const _hoisted_52 = {
  class: "upload-box-title-text"
};
const _hoisted_53 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_54 = {
  class: "upload-box-dashed"
};
const _hoisted_55 = {
  class: "upload-icon-group-box"
};
const _hoisted_56 = {
  class: "el-upload__text"
};
const _hoisted_57 = {
  style: {
    "font-size": "12px"
  }
};
const _hoisted_58 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "600px",
    "height": "300px",
    "background": "white",
    "overflow-y": "scroll"
  }
};
const _hoisted_59 = {
  style: {
    "width": "40%",
    "text-align": "right"
  }
};
const _hoisted_60 = {
  key: 2,
  class: "up-download-box"
};
const _hoisted_61 = {
  class: "activity-upload-list-box"
};
const _hoisted_62 = {
  class: "activity-list-box"
};
const _hoisted_63 = {
  class: "up-download-title"
};
const _hoisted_64 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center"
  }
};
const _hoisted_65 = {
  style: {
    "width": "100%",
    "text-align": "center",
    "margin-top": "19px"
  }
};
const _hoisted_66 = {
  class: "upload-box"
};
const _hoisted_67 = {
  class: "upload-box-title"
};
const _hoisted_68 = {
  class: "upload-box-title-text"
};
const _hoisted_69 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_70 = {
  class: "upload-box-dashed"
};
const _hoisted_71 = {
  class: "upload-icon-group-box"
};
const _hoisted_72 = {
  class: "el-upload__text"
};
const _hoisted_73 = {
  style: {
    "font-size": "12px"
  }
};
const _hoisted_74 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "600px",
    "height": "300px",
    "background": "white",
    "overflow-y": "scroll"
  }
};
const _hoisted_75 = {
  style: {
    "width": "40%",
    "text-align": "right"
  }
};
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "import-uploaded import-uploaded-history-none"
}, null, -1));
const _hoisted_77 = {
  class: "pane-area-box",
  style: {
    "width": "100%"
  }
};
const _hoisted_78 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "overflow": "auto"
  }
};
const _hoisted_79 = {
  class: "pane-area-box",
  style: {
    "width": "100%"
  }
};
const _hoisted_80 = {
  style: {
    "flex": "1",
    "overflow-y": "auto",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_81 = {
  class: "managers-item-box",
  style: {
    "font-size": "15px",
    "color": "#777",
    "margin-bottom": "20px"
  }
};
const _hoisted_82 = {
  class: "content-label",
  style: {
    "width": "120px"
  }
};
const _hoisted_83 = {
  class: "content-label",
  style: {
    "width": "180px"
  }
};
const _hoisted_84 = {
  class: "content-label",
  style: {
    "width": "120px"
  }
};
const _hoisted_85 = {
  class: "content-label",
  style: {
    "width": "180px"
  }
};
const _hoisted_86 = {
  class: "activity-right-info-plan detail-plan small-detail-plan",
  style: {
    "padding": "0 25px",
    "flex-direction": "column"
  }
};
const _hoisted_87 = {
  class: "pane-area-box",
  style: {
    "width": "100%",
    "flex-shrink": "0",
    "flex": "1",
    "overflow-y": "auto"
  }
};
const _hoisted_88 = {
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};
const _hoisted_89 = {
  class: "vendorTags"
};
const _hoisted_90 = ["onClick"];
const _hoisted_91 = {
  key: 0
};
const _hoisted_92 = {
  class: "activity-progress-item",
  style: {
    "margin-bottom": "3px"
  }
};
const _hoisted_93 = {
  style: {
    "font-size": "14px",
    "color": "#777",
    "width": "80px",
    "min-width": "80px",
    "height": "18px"
  }
};
const _hoisted_94 = {
  key: 0,
  style: {
    "font-size": "13px",
    "color": "#777",
    "flex": "1",
    "height": "18px"
  }
};
const _hoisted_95 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "120px",
    "padding-left": "20px"
  }
}, null, -1));
const _hoisted_96 = {
  class: "activity-progress-item"
};
const _hoisted_97 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "80px",
    "min-width": "80px"
  }
}, null, -1));
const _hoisted_98 = {
  style: {
    "font-size": "14px",
    "color": "#777",
    "flex": "1"
  }
};
const _hoisted_99 = {
  key: 0,
  style: {
    "width": "120px",
    "font-size": "13px",
    "color": "#777",
    "padding-left": "20px"
  }
};
const _hoisted_100 = {
  key: 1,
  style: {
    "width": "120px",
    "font-size": "13px",
    "color": "#777",
    "padding-left": "20px"
  }
};
const _hoisted_101 = {
  key: 0
};
const _hoisted_102 = {
  class: "activity-progress-item",
  style: {
    "margin-bottom": "3px"
  }
};
const _hoisted_103 = {
  style: {
    "font-size": "14px",
    "color": "#777",
    "width": "80px",
    "min-width": "80px",
    "height": "18px"
  }
};
const _hoisted_104 = {
  key: 0,
  style: {
    "font-size": "13px",
    "color": "#777",
    "flex": "1",
    "height": "18px"
  }
};
const _hoisted_105 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "120px",
    "padding-left": "20px"
  }
}, null, -1));
const _hoisted_106 = {
  class: "activity-progress-item"
};
const _hoisted_107 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "14px",
    "color": "#777",
    "width": "80px"
  }
}, null, -1));
const _hoisted_108 = {
  style: {
    "font-size": "14px",
    "color": "#777",
    "flex": "1"
  }
};
const _hoisted_109 = {
  key: 0,
  style: {
    "width": "120px",
    "font-size": "13px",
    "color": "#777",
    "padding-left": "20px"
  }
};
const _hoisted_110 = {
  key: 1,
  style: {
    "width": "120px",
    "font-size": "13px",
    "color": "#777",
    "padding-left": "20px"
  }
};
const _hoisted_111 = {
  class: "activity-progress-btn"
};
const _hoisted_112 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "600px",
    "height": "300px",
    "background": "white",
    "overflow-y": "scroll"
  }
};
const _hoisted_113 = {
  style: {
    "width": "40%",
    "text-align": "right"
  }
};
const _hoisted_114 = {
  class: "upload-box"
};
const _hoisted_115 = {
  class: "upload-box-title"
};
const _hoisted_116 = {
  class: "upload-box-title-text"
};
const _hoisted_117 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_118 = {
  class: "upload-box-dashed"
};
const _hoisted_119 = {
  class: "upload-icon-group-box"
};
const _hoisted_120 = {
  class: "el-upload__text"
};
const _hoisted_121 = {
  style: {
    "font-size": "12px"
  }
};
const _hoisted_122 = {
  class: "pane-area-box",
  style: {
    "width": "100%",
    "flex": "1",
    "overflow-y": "auto"
  }
};
const _hoisted_123 = {
  class: "vedioTitle",
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};
const _hoisted_124 = {
  style: {
    "color": "#777"
  }
};
const _hoisted_125 = {
  key: 0,
  class: "pane-area-box",
  style: {
    "width": "100%",
    "flex-shrink": "0",
    "overflow-y": "auto"
  }
};
const _hoisted_126 = ["onClick"];
const _hoisted_127 = {
  class: "pane-area-box",
  style: {
    "width": "100%",
    "flex": "1",
    "overflow-y": "auto"
  }
};
const _hoisted_128 = {
  class: "upload-box"
};
const _hoisted_129 = {
  class: "upload-box-title"
};
const _hoisted_130 = {
  class: "upload-box-title-text"
};
const _hoisted_131 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_132 = {
  class: "upload-box-dashed"
};
const _hoisted_133 = {
  class: "upload-icon-group-box"
};
const _hoisted_134 = {
  class: "el-upload__text"
};
const _hoisted_135 = {
  style: {
    "font-size": "12px"
  }
};
const _hoisted_136 = {
  style: {
    "min-height": "60px",
    "overflow-y": "auto"
  }
};
const _hoisted_137 = {
  style: {
    "margin-top": "10px",
    "gap": "10px",
    "margin-right": "10px"
  }
};
const _hoisted_138 = {
  class: "QRcodeBox",
  id: "QRcodeBox",
  ref: "QRcodeBox"
};
const _hoisted_139 = {
  class: "top"
};
const _hoisted_140 = {
  class: "top"
};
const _hoisted_141 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_142 = ["src"];
const _hoisted_143 = {
  class: "bottom"
};
const _hoisted_144 = {
  class: "bottom"
};
const _hoisted_145 = {
  class: "QRtitle"
};
const _hoisted_146 = {
  class: "copyQR"
};
const _hoisted_147 = {
  class: "ex-dialog-title"
};
const _hoisted_148 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "overflow-y": "auto"
  }
};
const _hoisted_149 = {
  style: {
    "display": "flex",
    "justify-content": "end",
    "padding": "10px 0px"
  }
};
const _hoisted_150 = {
  class: "videoBox"
};
const _hoisted_151 = {
  class: "labelBox"
};
const _hoisted_152 = {
  class: "labelTitle"
};
const _hoisted_153 = {
  class: "labelTitle",
  style: {
    "margin-left": "30px"
  }
};
const _hoisted_154 = {
  class: "labelBox"
};
const _hoisted_155 = {
  class: "labelTitle"
};
const _hoisted_156 = {
  class: "labelBox",
  style: {
    "margin-top": "30px"
  }
};
const _hoisted_157 = {
  class: "labelTitle"
};
const _hoisted_158 = {
  class: "labelBox",
  style: {
    "display": "flex",
    "align-items": "flex-start"
  }
};
const _hoisted_159 = {
  class: "labelTitle"
};
const _hoisted_160 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_image = _resolveComponent("a-image");
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_a_divider = _resolveComponent("a-divider");
  const _component_a_steps = _resolveComponent("a-steps");
  const _component_el_link = _resolveComponent("el-link");
  const _component_a_button = _resolveComponent("a-button");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_vxe_button = _resolveComponent("vxe-button");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_a_progress = _resolveComponent("a-progress");
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item");
  const _component_a_descriptions = _resolveComponent("a-descriptions");
  const _component_folder_card = _resolveComponent("folder-card");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_ex_dialog = _resolveComponent("ex-dialog");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_textarea = _resolveComponent("a-textarea");
  const _component_a_spin = _resolveComponent("a-spin");
  const _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_ctx.activity.activityData.logoOssUploadedName != null ? (_openBlock(), _createBlock(_component_a_image, {
    key: 0,
    style: {
      "flex": "1"
    },
    height: 280,
    src: _ctx.activity.activityData.logoOssUploadedName,
    preview: false,
    alt: "Activity Logo"
  }, null, 8, ["src"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.activity.activityData.activityName), 1), _ctx.permission.havePermission('活动管理', '新建活动') && _ctx.activity.activityData.isUpdate === true ? (_openBlock(), _createBlock(_component_svg_icon, {
    key: 0,
    iconName: "activityEdit",
    iconColor: '#6c6c6c',
    iconSize: "24px",
    onClick: _ctx.activityEditClick
  }, null, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.activity.activityData.activityBegin) + " 一 " + _toDisplayString(_ctx.activity.activityData.activityEnd), 1), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.activityData.tags, (x, index) => {
    return _openBlock(), _createElementBlock("span", {
      class: "tag",
      key: index
    }, " #" + _toDisplayString(x.activityTagNameZh), 1);
  }), 128))]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.activity.activityData.activityDescription), 1)])])]), _createVNode(_component_a_divider, {
    orientation: "left",
    orientationMargin: 25,
    style: {
      "font-size": "22px"
    }
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.participatingStore")), 1)]),
    _: 1
  }), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("activityDetail.storeType")), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("activityDetail.quantity")), 1), _createElementVNode("div", _hoisted_19, [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.total")) + "：", 1), _createElementVNode("span", {
    style: {
      "color": "#0042ff",
      "cursor": "pointer"
    },
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.storeDetailClick && _ctx.storeDetailClick(...args))
  }, [_createTextVNode(_toDisplayString(_ctx.activity.activityStat.totalQuantity) + " ", 1), _ctx.tokenData.type === 2 ? (_openBlock(), _createElementBlock("span", _hoisted_20, "(" + _toDisplayString(_ctx.activity.activityStat.activityVendorStoreQuantity) + ")", 1)) : _createCommentVNode("", true)])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.activityStat.activityStoreTypeQuantity, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-title-item",
      key: index,
      onClick: $event => _ctx.storeTypeClick(item.storeTypeId)
    }, [_createElementVNode("div", _hoisted_22, _toDisplayString(item.storeTypeNameZh), 1), _createElementVNode("div", _hoisted_23, _toDisplayString(item.quantity), 1), _hoisted_24], 8, _hoisted_21);
  }), 128))])])])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_ctx.tokenData.type == 2 ? (_openBlock(), _createBlock(_component_a_divider, {
    key: 0,
    orientation: "left",
    orientationMargin: 0,
    style: {
      "font-size": "22px"
    }
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.activityUploadList")), 1)]),
    _: 1
  })) : _createCommentVNode("", true), _ctx.tokenData.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_a_steps, {
    "progress-dot": "",
    current: _ctx.stepsCurrent,
    "onUpdate:current": _cache[1] || (_cache[1] = $event => _ctx.stepsCurrent = $event),
    items: _ctx.activity.stepsItems,
    style: {
      "width": "100%",
      "display": "flex",
      "justify-content": "center",
      "margin-top": "5px"
    }
  }, null, 8, ["current", "items"]), _ctx.stepsCurrent === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("activityDetail.activityStoreListAndGraphicOrderDownload")), 1), _createVNode(_component_el_link, {
    disabled: !_ctx.permission.havePermission('活动管理', '上传活动店铺清单'),
    onClick: _ctx.exportActivityStoreClick,
    style: {
      "color": "#0042ff",
      "font-size": "14px",
      "height": "24px"
    }
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.templateDownload")), 1)]),
    _: 1
  }, 8, ["disabled", "onClick"])])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createVNode(_component_el_popover, {
    visible: _ctx.uploadStoreLocationPopoverVisible,
    placement: "bottom",
    trigger: "click",
    width: "auto",
    teleported: true,
    "popper-class": "upload-box-popper"
  }, {
    reference: _withCtx(() => [_createVNode(_component_a_button, {
      disabled: !(_ctx.permission.havePermission('活动管理', '上传活动店铺清单') && _ctx.activity.activityData.isUpdate === true),
      class: "sts-button default",
      color: "black",
      onClick: _ctx.openUploadStoreLocationPopover,
      style: {
        "width": "80px",
        "margin-right": "15px"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.uploadFile")), 1)]),
      _: 1
    }, 8, ["disabled", "onClick"])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("activityDetail.dataUpload")), 1), _createVNode(_component_svg_icon, {
      iconName: "close",
      iconColor: 'black',
      iconSize: "15px",
      style: {
        "cursor": "pointer",
        "padding": "3px"
      },
      onClick: _cache[2] || (_cache[2] = $event => _ctx.uploadStoreLocationPopoverVisible = false)
    })]), _createVNode(_component_el_upload, {
      "on-exceed": _ctx.handleStoreLocationExceed,
      class: "upload-pane",
      drag: "",
      ref: "uploadStoreLocation",
      action: _ctx.uploadStoreLocationData.signatureData.host,
      "before-upload": _ctx.handleStoreLocationBeforeUpload,
      "on-success": _ctx.handleStoreLocationOnSuccess,
      data: _ctx.uploadStoreLocationData.data,
      limit: 1,
      "file-list": _ctx.uploadStoreLocationData.fileList
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_37, [_createVNode(_component_a_button, {
        class: "sts-button default",
        color: "#539ce0",
        style: {
          "width": "100px",
          "margin": "5px 0px"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.browse")), 1)]),
        _: 1
      }), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createVNode(_component_svg_icon, {
        iconName: "Excel",
        iconSize: "18px"
      }), _createVNode(_component_svg_icon, {
        iconName: "upload",
        iconSize: "18px"
      })]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("activityDetail.dragOrClickUpload")), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("activityDetail.supportFileType")), 1)])])])]),
      _: 1
    }, 8, ["on-exceed", "action", "before-upload", "on-success", "data", "file-list"])])]),
    _: 1
  }, 8, ["visible"]), _ctx.activity.activityImportUploaded[8] == null ? (_openBlock(), _createBlock(_component_a_button, {
    key: 0,
    class: "sts-button default",
    color: "black",
    style: {
      "width": "80px"
    },
    disabled: ""
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.historyFile")), 1)]),
    _: 1
  })) : _createCommentVNode("", true), _ctx.activity.activityImportUploaded[8] != null ? (_openBlock(), _createBlock(_component_el_popover, {
    key: 1,
    placement: "top-start",
    trigger: "hover",
    "popper-style": "min-width: 0px;width: auto;",
    "show-arrow": false
  }, {
    reference: _withCtx(() => [_createVNode(_component_a_button, {
      class: "sts-button default",
      style: {
        "width": "80px",
        "background-color": "#5ab46b !important",
        "color": "white !important",
        "border": "none !important"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.historyFile")), 1)]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_42, [_createVNode(_component_a_divider, {
      orientation: "left",
      orientationMargin: 0,
      style: {
        "font-size": "22px"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.historyFile")), 1)]),
      _: 1
    }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.activityImportUploaded[8].activityImportUploaded, (uploaded, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        style: {
          "display": "flex",
          "justify-content": "space-between",
          "font-size": "12px",
          "align-items": "center",
          "margin-bottom": "22px"
        }
      }, [_createVNode(_component_el_tooltip, {
        content: uploaded.fileName,
        placement: "top",
        effect: "dark",
        "open-delay": 500,
        "popper-class": "custom-tooltip"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_link, {
          href: uploaded.url,
          style: {
            "color": "#0763db",
            "width": "60%",
            "justify-content": "flex-start",
            "text-wrap": "nowrap",
            "overflow-x": "hidden"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(uploaded.fileName), 1)]),
          _: 2
        }, 1032, ["href"])]),
        _: 2
      }, 1032, ["content"]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", null, " Uploaded By:" + _toDisplayString(uploaded.lastName) + _toDisplayString(" ") + _toDisplayString(uploaded.firstName) + "," + _toDisplayString(uploaded.createTime), 1)])]);
    }), 128))])]),
    _: 1
  })) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true), _ctx.stepsCurrent === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t("activityDetail.supplierStoreList")), 1), _createVNode(_component_el_link, {
    onClick: _ctx.exportActivityStoreLocationClick,
    style: {
      "color": "#0042ff",
      "font-size": "14px",
      "height": "24px"
    }
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.templateDownload")), 1)]),
    _: 1
  }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createVNode(_component_el_popover, {
    visible: _ctx.uploadActivityInstallationPopoverVisible,
    placement: "bottom",
    trigger: "click",
    width: "auto",
    teleported: true,
    "popper-class": "upload-box-popper"
  }, {
    reference: _withCtx(() => [_createVNode(_component_a_button, {
      disabled: !(_ctx.permission.havePermission('活动管理', '上传供应商负责店铺') && _ctx.activity.activityData.isUpdate === true),
      class: "sts-button default",
      color: "black",
      onClick: _ctx.openUploadActivityInstallationPopover,
      style: {
        "width": "80px",
        "margin-right": "15px"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.uploadFile")), 1)]),
      _: 1
    }, 8, ["disabled", "onClick"])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("activityDetail.dataUpload")), 1), _createVNode(_component_svg_icon, {
      iconName: "close",
      iconColor: 'black',
      iconSize: "15px",
      style: {
        "cursor": "pointer",
        "padding": "3px"
      },
      onClick: _cache[3] || (_cache[3] = $event => _ctx.uploadActivityInstallationPopoverVisible = false)
    })]), _createVNode(_component_el_upload, {
      "on-exceed": _ctx.handleActivityInstallationExceed,
      class: "upload-pane",
      drag: "",
      ref: "uploadActivityInstallation",
      action: _ctx.uploadActivityInstallationData.signatureData.host,
      "before-upload": _ctx.handleActivityInstallationBeforeUpload,
      "on-success": _ctx.handleActivityInstallationOnSuccess,
      data: _ctx.uploadActivityInstallationData.data,
      limit: 1,
      "file-list": _ctx.uploadActivityInstallationData.fileList
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_53, [_createVNode(_component_a_button, {
        class: "sts-button default",
        color: "#539ce0",
        style: {
          "width": "100px",
          "margin": "5px 0px"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.browse")), 1)]),
        _: 1
      }), _createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createVNode(_component_svg_icon, {
        iconName: "Excel",
        iconSize: "18px"
      }), _createVNode(_component_svg_icon, {
        iconName: "upload",
        iconSize: "18px"
      })]), _createElementVNode("div", _hoisted_56, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("activityDetail.dragOrClickUpload")), 1), _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$t("activityDetail.supportFileType")), 1)])])])]),
      _: 1
    }, 8, ["on-exceed", "action", "before-upload", "on-success", "data", "file-list"])])]),
    _: 1
  }, 8, ["visible"]), _ctx.activity.activityImportUploaded[13] == null ? (_openBlock(), _createBlock(_component_a_button, {
    key: 0,
    class: "sts-button default",
    color: "black",
    style: {
      "width": "80px"
    },
    disabled: ""
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.historyFile")), 1)]),
    _: 1
  })) : _createCommentVNode("", true), _ctx.activity.activityImportUploaded[13] != null ? (_openBlock(), _createBlock(_component_el_popover, {
    key: 1,
    placement: "top-start",
    trigger: "hover",
    "popper-style": "min-width: 0px;width: auto;",
    "show-arrow": false
  }, {
    reference: _withCtx(() => [_createVNode(_component_a_button, {
      class: "sts-button default",
      style: {
        "width": "80px",
        "background-color": "#5ab46b !important",
        "color": "white !important",
        "border": "none !important"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.historyFile")), 1)]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_58, [_createVNode(_component_a_divider, {
      orientation: "left",
      orientationMargin: 0,
      style: {
        "font-size": "22px"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.historyFile")), 1)]),
      _: 1
    }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.activityImportUploaded[13].activityImportUploaded, (uploaded, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        style: {
          "display": "flex",
          "justify-content": "space-between",
          "font-size": "12px",
          "align-items": "center",
          "margin-bottom": "22px"
        }
      }, [_createVNode(_component_el_tooltip, {
        content: uploaded.fileName,
        placement: "top",
        effect: "dark",
        "open-delay": 500,
        "popper-class": "custom-tooltip"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_link, {
          onClick: $event => _ctx.downloadFile(uploaded.url, uploaded.fileName),
          style: {
            "color": "#0763db",
            "width": "60%",
            "justify-content": "flex-start",
            "text-wrap": "nowrap",
            "overflow-x": "hidden"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(uploaded.fileName), 1)]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 2
      }, 1032, ["content"]), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", null, " Uploaded By:" + _toDisplayString(uploaded.lastName) + _toDisplayString(" ") + _toDisplayString(uploaded.firstName) + "," + _toDisplayString(uploaded.createTime), 1)])]);
    }), 128))])]),
    _: 1
  })) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true), _ctx.stepsCurrent === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t("activityDetail.bulkInstallAppointment")), 1), _createVNode(_component_el_link, {
    onClick: _ctx.exportActivityInstallationClick,
    style: {
      "color": "#0042ff",
      "font-size": "14px",
      "height": "24px"
    }
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.templateDownload")), 1)]),
    _: 1
  }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createVNode(_component_el_popover, {
    visible: _ctx.uploadInstallationPopoverVisible,
    placement: "bottom",
    trigger: "click",
    width: "auto",
    teleported: true,
    "popper-class": "upload-box-popper"
  }, {
    reference: _withCtx(() => [_createVNode(_component_a_button, {
      disabled: !(_ctx.permission.havePermission('活动管理', '上传批量安装预约') && _ctx.activity.activityData.isUpdate === true),
      class: "sts-button default",
      color: "black",
      onClick: _ctx.openUploadInstallationPopover,
      style: {
        "width": "80px",
        "margin-right": "15px"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.uploadFile")), 1)]),
      _: 1
    }, 8, ["disabled", "onClick"])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t("activityDetail.dataUpload")), 1), _createVNode(_component_vxe_button, {
      status: "success",
      size: "mini",
      content: _ctx.$t('activityDetail.syncAppointmentTime'),
      style: {
        "padding": "0px 4px",
        "height": "20px",
        "margin-right": "5px"
      },
      onClick: _ctx.dsyncInstallationDateClick
    }, null, 8, ["content", "onClick"]), _createVNode(_component_svg_icon, {
      iconName: "close",
      iconColor: 'black',
      iconSize: "15px",
      style: {
        "cursor": "pointer",
        "padding": "3px"
      },
      onClick: _cache[4] || (_cache[4] = $event => _ctx.uploadInstallationPopoverVisible = false)
    })]), _createVNode(_component_el_upload, {
      "on-exceed": _ctx.handleInstallationExceed,
      class: "upload-pane",
      drag: "",
      ref: "uploadInstallation",
      action: _ctx.uploadInstallationData.signatureData.host,
      "before-upload": _ctx.handleInstallationBeforeUpload,
      "on-success": _ctx.handleInstallationOnSuccess,
      data: _ctx.uploadInstallationData.data,
      limit: 1,
      "file-list": _ctx.uploadInstallationData.fileList
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_69, [_createVNode(_component_a_button, {
        class: "sts-button default",
        color: "#539ce0",
        style: {
          "width": "100px",
          "margin": "5px 0px"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.browse")), 1)]),
        _: 1
      }), _createElementVNode("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_createVNode(_component_svg_icon, {
        iconName: "Excel",
        iconSize: "18px"
      }), _createVNode(_component_svg_icon, {
        iconName: "upload",
        iconSize: "18px"
      })]), _createElementVNode("div", _hoisted_72, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("activityDetail.dragOrClickUpload")), 1), _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.$t("activityDetail.supportFileType")), 1)])])])]),
      _: 1
    }, 8, ["on-exceed", "action", "before-upload", "on-success", "data", "file-list"])])]),
    _: 1
  }, 8, ["visible"]), _ctx.activity.activityImportUploaded[14] == null ? (_openBlock(), _createBlock(_component_a_button, {
    key: 0,
    class: "sts-button default",
    color: "black",
    style: {
      "width": "80px"
    },
    disabled: ""
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.historyFile")), 1)]),
    _: 1
  })) : _createCommentVNode("", true), _ctx.activity.activityImportUploaded[14] != null ? (_openBlock(), _createBlock(_component_el_popover, {
    key: 1,
    placement: "top-start",
    trigger: "hover",
    "popper-style": "min-width: 0px;width: auto;",
    "show-arrow": false
  }, {
    reference: _withCtx(() => [_createVNode(_component_a_button, {
      class: "sts-button default",
      style: {
        "width": "80px",
        "background-color": "#5ab46b !important",
        "color": "white !important",
        "border": "none !important"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.historyFile")), 1)]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_74, [_createVNode(_component_a_divider, {
      orientation: "left",
      orientationMargin: 0,
      style: {
        "font-size": "22px"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.historyFile")), 1)]),
      _: 1
    }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.activityImportUploaded[14].activityImportUploaded, (uploaded, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        style: {
          "display": "flex",
          "justify-content": "space-between",
          "font-size": "12px",
          "align-items": "center",
          "margin-bottom": "22px"
        }
      }, [_createVNode(_component_el_tooltip, {
        content: uploaded.fileName,
        placement: "top",
        effect: "dark",
        "open-delay": 500,
        "popper-class": "custom-tooltip"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_link, {
          onClick: $event => _ctx.downloadFile(uploaded.url, uploaded.fileName),
          style: {
            "color": "#0763db",
            "width": "60%",
            "justify-content": "flex-start",
            "text-wrap": "nowrap",
            "overflow-x": "hidden"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            iconName: "Download",
            iconColor: '#0042ff',
            iconSize: "15px"
          }), _createTextVNode(" " + _toDisplayString(uploaded.fileName), 1)]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 2
      }, 1032, ["content"]), _createElementVNode("div", _hoisted_75, [_createElementVNode("div", null, " Uploaded By:" + _toDisplayString(uploaded.lastName) + _toDisplayString(" ") + _toDisplayString(uploaded.firstName) + "," + _toDisplayString(uploaded.createTime), 1)])]);
    }), 128))])]),
    _: 1
  })) : _createCommentVNode("", true)]), _hoisted_76])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createVNode(_component_a_divider, {
    orientation: "left",
    orientationMargin: 0,
    style: {
      "font-size": "22px"
    }
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.supplierStoreList")), 1)]),
    _: 1
  }), _createElementVNode("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, [_createVNode(_component_vxe_table, {
    border: "none",
    "header-cell-class-name": "header-cell-class-name",
    size: "small",
    ref: "storeTable",
    "row-config": {
      isHover: false
    },
    data: _ctx.activity.activityStat.installationVendors,
    "sort-config": {
      showIcon: false
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_vxe_column, {
      field: "vendorName",
      title: _ctx.$t('activityDetail.supplier'),
      align: 'left'
    }, null, 8, ["title"]), _createVNode(_component_vxe_column, {
      field: "vendorTypeNameZh",
      title: _ctx.$t('activityDetail.serviceContent')
    }, null, 8, ["title"]), _createVNode(_component_vxe_column, {
      field: "quantityRatio",
      title: _ctx.$t('activityDetail.serviceQuantity')
    }, null, 8, ["title"]), _createVNode(_component_vxe_column, {
      field: "appointmentQuantityRatio",
      title: _ctx.$t('activityDetail.appointmentQuantity')
    }, null, 8, ["title"]), _createVNode(_component_vxe_column, {
      align: 'center',
      title: _ctx.$t('activityDetail.constructionCode')
    }, {
      default: _withCtx(({
        row
      }) => [_ctx.tokenData.type == 2 && _ctx.tokenData.managerId == row.vendorId || _ctx.tokenData.type != 2 ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        style: {
          "cursor": "pointer"
        },
        onClick: $event => _ctx.siteCodeClick(row),
        iconName: "qr",
        iconSize: "18px"
      }, null, 8, ["onClick"])) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["title"])]),
    _: 1
  }, 8, ["data"])])]), _createVNode(_component_a_divider, {
    orientation: "left",
    orientationMargin: 0,
    style: {
      "font-size": "22px"
    }
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.principal")), 1)]),
    _: 1
  }), _createElementVNode("div", _hoisted_79, [_createElementVNode("div", _hoisted_80, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.activityManagers, (activityManagers, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: {
        "display": "flex",
        "flex-direction": "column"
      }
    }, [_createVNode(_component_a_divider, {
      style: {
        "font-size": "15px",
        "color": "#777"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(activityManagers.organizationName), 1)]),
      _: 2
    }, 1024), _createElementVNode("div", _hoisted_81, [_createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.$t("activityDetail.name")), 1), _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.$t("activityDetail.responsibleSection")), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityManagers.managers, (managers, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        class: "managers-item-box",
        style: {
          "font-size": "12px",
          "color": "#777",
          "margin-bottom": "16px"
        }
      }, [_createElementVNode("div", _hoisted_84, _toDisplayString(managers.lastName) + _toDisplayString(" ") + _toDisplayString(managers.firstName), 1), _createElementVNode("div", _hoisted_85, _toDisplayString(managers.managedArea), 1)]);
    }), 128))]);
  }), 128))])])])]), _createElementVNode("div", _hoisted_86, [_createVNode(_component_a_divider, {
    orientation: "left",
    orientationMargin: 0,
    style: {
      "font-size": "22px"
    }
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.activityProgress")), 1)]),
    _: 1
  }), _createElementVNode("div", _hoisted_87, [_createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_createElementVNode("span", {
    onClick: _cache[5] || (_cache[5] = $event => _ctx.chooseVendorProgress('all', 0)),
    class: _normalizeClass({
      spanCheck: _ctx.progressType == 'all' && _ctx.progressIndex == 0
    })
  }, _toDisplayString(_ctx.$t("activityDetail.all")), 3), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.activityStat.activityVendorStats, (x, index) => {
    return _openBlock(), _createElementBlock("span", {
      key: index,
      onClick: $event => _ctx.chooseVendorProgress('vendor', index),
      class: _normalizeClass({
        spanCheck: _ctx.progressType == 'vendor' && _ctx.progressIndex == index
      })
    }, _toDisplayString(x.vendorName), 11, _hoisted_90);
  }), 128))]), _ctx.permission.havePermission('安装及发货进度', '查看进度') ? (_openBlock(), _createBlock(_component_a_button, {
    key: 0,
    class: "sts-button-circle-icon default",
    style: {
      "width": "80px",
      "height": "25px",
      "margin-left": "20px"
    },
    color: "black",
    onClick: _ctx.goInstallCover
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.detail")), 1)]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createVNode(_component_a_divider), _createElementVNode("div", null, [_ctx.progressType === 'all' ? (_openBlock(), _createElementBlock("div", _hoisted_91, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.activityStat.totalProgress, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "",
      style: {
        "margin-bottom": "6px"
      }
    }, [_createElementVNode("div", _hoisted_92, [_createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.progressText[index]), 1), index > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(item.quantity) + "/" + _toDisplayString(item.totalQuantity) + "(Touchpoint) ", 1)) : _createCommentVNode("", true), _hoisted_95]), _createElementVNode("div", _hoisted_96, [_hoisted_97, _createElementVNode("div", _hoisted_98, [_createVNode(_component_a_progress, {
      style: {
        "flex": "1",
        "margin-bottom": "0"
      },
      "stroke-width": 13,
      "stroke-color": {
        '0%': '#FEBD2E',
        '100%': '#27C83E'
      },
      percent: item.percentage,
      status: "active",
      showInfo: false,
      trailColor: "#f0f0f0"
    }, null, 8, ["percent"])]), index > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_99, _toDisplayString(item.storeQuantity) + "/" + _toDisplayString(item.storeTotalQuantity) + "(Door) ", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString(item.quantity) + "/" + _toDisplayString(item.totalQuantity) + "(Door) ", 1))])]);
  }), 128))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.activityStat.activityVendorStats, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_ctx.progressType == 'vendor' && _ctx.progressIndex == index ? (_openBlock(), _createElementBlock("div", _hoisted_101, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.progress, (subItem, subIndex) => {
      return _openBlock(), _createElementBlock("div", {
        key: subIndex,
        class: "",
        style: {
          "margin-bottom": "6px"
        }
      }, [_createElementVNode("div", _hoisted_102, [_createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.progressText[subIndex]), 1), subIndex > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_104, _toDisplayString(subItem.quantity) + "/" + _toDisplayString(subItem.totalQuantity) + "(Touchpoint) ", 1)) : _createCommentVNode("", true), _hoisted_105]), _createElementVNode("div", _hoisted_106, [_hoisted_107, _createElementVNode("div", _hoisted_108, [_createVNode(_component_a_progress, {
        style: {
          "flex": "1",
          "margin-bottom": "0"
        },
        "stroke-width": 13,
        "stroke-color": {
          '0%': '#FEBD2E',
          '100%': '#27C83E'
        },
        percent: subItem.percentage,
        status: "active",
        showInfo: false,
        trailColor: "#f0f0f0"
      }, null, 8, ["percent"])]), subIndex > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_109, _toDisplayString(subItem.storeQuantity) + "/" + _toDisplayString(subItem.storeTotalQuantity) + "(Door) ", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_110, _toDisplayString(subItem.quantity) + "/" + _toDisplayString(subItem.totalQuantity) + "(Door) ", 1))])]);
    }), 128)), _createElementVNode("div", _hoisted_111, [_ctx.permission.havePermission('安装及发货进度', '物流表上传') && _ctx.tokenData.type === 2 && item.vendorId ? (_openBlock(), _createBlock(_component_el_link, {
      key: 0,
      onClick: _ctx.exportLogisticsExportClick,
      style: {
        "color": "#0042ff",
        "font-size": "14px",
        "height": "24px",
        "margin-top": "3px",
        "margin-right": "15px"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.templateDownload")), 1)]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true), _ctx.activity.activityImportUploaded[15] != null ? (_openBlock(), _createBlock(_component_el_popover, {
      key: 1,
      placement: "top-start",
      trigger: "hover",
      "popper-style": "min-width: 0px;width: auto;",
      "show-arrow": false
    }, {
      reference: _withCtx(() => [_createVNode(_component_a_button, {
        class: "sts-button default",
        style: {
          "margin-right": "15px"
        },
        color: "black"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.uploadHistory")), 1)]),
        _: 1
      })]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_112, [_createVNode(_component_a_divider, {
        orientation: "left",
        orientationMargin: 0,
        style: {
          "font-size": "22px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.historyFile")), 1)]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.activityImportUploaded[15].activityImportUploaded, (uploaded, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          style: {
            "display": "flex",
            "justify-content": "space-between",
            "font-size": "12px",
            "align-items": "center",
            "margin-bottom": "22px"
          }
        }, [_createVNode(_component_el_tooltip, {
          content: uploaded.fileName,
          placement: "top",
          effect: "dark",
          "open-delay": 500,
          "popper-class": "custom-tooltip"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_link, {
            href: uploaded.url,
            style: {
              "color": "#0763db",
              "width": "60%",
              "justify-content": "flex-start",
              "text-wrap": "nowrap",
              "overflow-x": "hidden"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_svg_icon, {
              iconName: "Download",
              iconColor: '#0042ff',
              iconSize: "15px"
            }), _createTextVNode(" " + _toDisplayString(uploaded.fileName), 1)]),
            _: 2
          }, 1032, ["href"])]),
          _: 2
        }, 1032, ["content"]), _createElementVNode("div", _hoisted_113, [_createElementVNode("div", null, " Uploaded By:" + _toDisplayString(uploaded.lastName) + _toDisplayString(" ") + _toDisplayString(uploaded.firstName) + "," + _toDisplayString(uploaded.createTime), 1)])]);
      }), 128))])]),
      _: 2
    }, 1024)) : _createCommentVNode("", true), _createVNode(_component_el_popover, {
      visible: _ctx.uploadConverPopoverVisible,
      placement: "bottom",
      trigger: "click",
      width: "auto",
      teleported: false,
      "popper-class": "upload-box-popper"
    }, {
      reference: _withCtx(() => [_ctx.permission.havePermission('安装及发货进度', '物流表上传') && _ctx.tokenData.type === 2 && item.vendorId ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        class: "sts-button default",
        color: "black",
        onClick: _ctx.openUploadConverPopover
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.logisticsUpload")), 1)]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_114, [_createElementVNode("div", _hoisted_115, [_createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.$t("activityDetail.logisticsUpload")), 1), _createVNode(_component_svg_icon, {
        iconName: "close",
        iconColor: 'black',
        iconSize: "15px",
        style: {
          "cursor": "pointer",
          "padding": "3px"
        },
        onClick: _cache[6] || (_cache[6] = $event => _ctx.uploadConverPopoverVisible = false)
      })]), _createVNode(_component_el_upload, {
        "on-exceed": _ctx.handleConverExceed,
        class: "upload-pane",
        drag: "",
        ref_for: true,
        ref: "uploadConverPane",
        action: _ctx.uploadConverData.signatureData.host,
        "before-upload": _ctx.handleConverBeforeUpload,
        "on-success": _ctx.handleConverOnSuccess,
        data: _ctx.uploadConverData.data,
        limit: 1,
        "file-list": _ctx.uploadConverData.fileList
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_117, [_createVNode(_component_a_button, {
          class: "sts-button default",
          color: "#539ce0",
          style: {
            "width": "100px",
            "margin": "5px 0px"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.browse")), 1)]),
          _: 1
        }), _createElementVNode("div", _hoisted_118, [_createElementVNode("div", _hoisted_119, [_createVNode(_component_svg_icon, {
          iconName: "Excel",
          iconSize: "18px"
        }), _createVNode(_component_svg_icon, {
          iconName: "upload",
          iconSize: "18px"
        })]), _createElementVNode("div", _hoisted_120, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("activityDetail.dragOrClickUpload")), 1), _createElementVNode("div", _hoisted_121, _toDisplayString(_ctx.$t("activityDetail.supportFileType")), 1)])])])]),
        _: 1
      }, 8, ["on-exceed", "action", "before-upload", "on-success", "data", "file-list"])])]),
      _: 2
    }, 1032, ["visible"])])])) : _createCommentVNode("", true)]);
  }), 128))])]), _createVNode(_component_a_divider, {
    orientation: "left",
    orientationMargin: 0,
    style: {
      "font-size": "22px"
    }
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.videoPubProgress")), 1)]),
    _: 1
  }), _createElementVNode("div", _hoisted_122, [_createElementVNode("div", _hoisted_123, [_createElementVNode("span", _hoisted_124, _toDisplayString(_ctx.$t("activityDetail.taskInfo")), 1), _withDirectives(_createVNode(_component_a_button, {
    class: "sts-button-circle-icon default",
    style: {
      "width": "80px",
      "height": "25px",
      "margin-left": "20px"
    },
    color: "black",
    onClick: _ctx.publishTask
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.addTask")), 1)]),
    _: 1
  }, 8, ["onClick"]), [[_vShow, _ctx.activity.videoTaskInfo.length === 0]]), _ctx.permission.havePermission('视频发布', '新增') ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
    key: 0,
    class: "sts-button-circle-icon default",
    style: {
      "width": "80px",
      "height": "25px",
      "margin-left": "20px"
    },
    color: "black",
    onClick: _ctx.editTask
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.editTask")), 1)]),
    _: 1
  }, 8, ["onClick"])), [[_vShow, _ctx.activity.videoTaskInfo.length != 0]]) : _createCommentVNode("", true)]), _createVNode(_component_a_divider, {
    orientation: "left",
    orientationMargin: 0,
    style: {
      "font-size": "22px"
    }
  }), _ctx.activity.videoTaskInfo.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_125, [_createVNode(_component_a_descriptions, {
    bordered: "",
    column: 1
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.videoTaskInfo[0].videoAddress, (x, index) => {
      return _openBlock(), _createBlock(_component_a_descriptions_item, {
        label: _ctx.$t('activityDetail.link') + (index + 1),
        labelStyle: {
          padding: '5px 10px',
          width: '60px'
        }
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          style: {
            "color": "#1677ff",
            "cursor": "pointer",
            "text-decoration": "underline"
          },
          onClick: $event => _ctx.openLink(x)
        }, _toDisplayString(_ctx.activity.videoTaskInfo[0].videoAddress[index]), 9, _hoisted_126)]),
        _: 2
      }, 1032, ["label"]);
    }), 256)), _createVNode(_component_a_descriptions_item, {
      label: _ctx.$t('activityDetail.remark'),
      labelStyle: {
        padding: '5px 10px',
        width: '60px'
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.activity.videoTaskInfo[0].videoTaskDesc), 1)]),
      _: 1
    }, 8, ["label"])]),
    _: 1
  })])) : _createCommentVNode("", true)]), _createVNode(_component_a_divider, {
    orientation: "left",
    orientationMargin: 0,
    style: {
      "font-size": "22px"
    }
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.activityFile")), 1)]),
    _: 1
  }), _createElementVNode("div", _hoisted_127, [_ctx.permission.havePermission('活动管理', '活动文件管理') && _ctx.activity.activityData.isUpdate === true ? (_openBlock(), _createBlock(_component_el_popover, {
    key: 0,
    visible: _ctx.uploadFilePopoverVisible,
    placement: "bottom",
    trigger: "click",
    width: "auto",
    teleported: false,
    "popper-class": "upload-box-popper"
  }, {
    reference: _withCtx(() => [_createVNode(_component_a_button, {
      class: "sts-button default upload-file-btn",
      color: "black",
      onClick: _ctx.openUploadFilePopover,
      style: {
        "width": "80px"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.fileUpload")), 1)]),
      _: 1
    }, 8, ["onClick"])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_128, [_createElementVNode("div", _hoisted_129, [_createElementVNode("div", _hoisted_130, _toDisplayString(_ctx.$t("activityDetail.activityFileUpload")), 1), _createVNode(_component_svg_icon, {
      iconName: "close",
      iconColor: 'black',
      iconSize: "15px",
      style: {
        "cursor": "pointer",
        "padding": "3px"
      },
      onClick: _cache[7] || (_cache[7] = $event => _ctx.uploadFilePopoverVisible = false)
    })]), _createVNode(_component_el_upload, {
      "on-exceed": _ctx.handleFileExceed,
      class: "upload-pane",
      drag: "",
      ref: "uploadFile",
      action: _ctx.uploadFileData.signatureData.host,
      "before-upload": _ctx.handleFileBeforeUpload,
      "on-success": _ctx.handleFileOnSuccess,
      data: _ctx.uploadFileData.data,
      limit: 1,
      "file-list": _ctx.uploadFileData.fileList
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_131, [_createVNode(_component_a_button, {
        class: "sts-button default",
        color: "#539ce0",
        style: {
          "width": "100px",
          "margin": "5px 0px"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.browse")), 1)]),
        _: 1
      }), _createElementVNode("div", _hoisted_132, [_createElementVNode("div", _hoisted_133, [_createVNode(_component_svg_icon, {
        iconName: "Excel",
        iconSize: "18px"
      }), _createVNode(_component_svg_icon, {
        iconName: "upload",
        iconSize: "18px"
      })]), _createElementVNode("div", _hoisted_134, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("activityDetail.dragOrClickUpload")), 1), _createElementVNode("div", _hoisted_135, _toDisplayString(_ctx.$t("activityDetail.supportFileType")), 1)])])])]),
      _: 1
    }, 8, ["on-exceed", "action", "before-upload", "on-success", "data", "file-list"])])]),
    _: 1
  }, 8, ["visible"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_136, [_createElementVNode("div", _hoisted_137, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.activityData.uploaded, (item, index) => {
    return _openBlock(), _createBlock(_component_folder_card, {
      key: index,
      close: _ctx.permission.havePermission('活动管理', '活动文件管理') && _ctx.activity.activityData.isUpdate === true && (_ctx.tokenData.type === 1 || _ctx.tokenData.type !== 1 && item.managerType == _ctx.tokenData.type && item.managerId == _ctx.tokenData.managerId),
      "file-name": item.fileName,
      "file-date": item.date,
      url: item.uploadedOssName,
      onRemove: $event => _ctx.removeFile(item)
    }, null, 8, ["close", "file-name", "file-date", "url", "onRemove"]);
  }), 128))])])])])])])]), _createVNode(_component_el_dialog, {
    modelValue: _ctx.QRcodeVisible,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.QRcodeVisible = $event),
    width: "30%",
    "align-center": "",
    modal: false,
    "append-to-body": "",
    style: {
      "min-width": "300px",
      "max-width": "300px",
      "min-height": "300px"
    },
    "show-close": false
  }, {
    header: _withCtx(() => [_createElementVNode("div", _hoisted_145, _toDisplayString(_ctx.activity.activityData.activityName), 1), _createElementVNode("div", _hoisted_146, [_createVNode(_component_svg_icon, {
      iconName: "copy",
      iconSize: "20px",
      onClick: _cache[8] || (_cache[8] = $event => _ctx.copyQrcode())
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_138, [_createElementVNode("div", _hoisted_139, _toDisplayString(_ctx.getDate(new Date().getTime(), 1) + "-" + _ctx.getDate(new Date().getTime() + 7 * 24 * 60 * 60 * 1000, 1)), 1), _createElementVNode("div", _hoisted_140, _toDisplayString(_ctx.QRcodeMsg.vendorName), 1), _createElementVNode("div", _hoisted_141, [_createElementVNode("img", {
      style: {
        "width": "150px",
        "height": "150px"
      },
      src: _ctx.wxCodeImage
    }, null, 8, _hoisted_142)]), _createElementVNode("div", _hoisted_143, _toDisplayString(_ctx.getDate(new Date().getTime())), 1), _createElementVNode("div", _hoisted_144, _toDisplayString(_ctx.getDate(new Date().getTime() + 7 * 24 * 60 * 60 * 1000)), 1)], 512)]),
    _: 1
  }, 8, ["modelValue"]), (_openBlock(), _createBlock(_Teleport, {
    to: "body"
  }, [_createVNode(_component_ex_dialog, {
    extraStyle: "min-width: 380px;\n      max-width: 600px;\n      width: 80%;\n      height: 400px;\n      font-size: 14px;\n      padding:10px",
    "append-to-body": "",
    isVisible: _ctx.activity.activityImportMessageVisible
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_147, _toDisplayString(_ctx.$t("activityDetail.validationError")), 1), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_148, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.activityImportMessages, (message, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index
      }, _toDisplayString(message), 1);
    }), 128))]), _createElementVNode("div", _hoisted_149, [_createVNode(_component_a_button, {
      onClick: _cache[10] || (_cache[10] = $event => _ctx.activity.activityImportMessageVisible = false),
      style: {
        "border-color": "black",
        "color": "black"
      },
      class: "sts-button default"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.close")), 1)]),
      _: 1
    })])]),
    _: 1
  }, 8, ["isVisible"])])), _createVNode(_component_a_modal, {
    open: _ctx.videoDialogVisible,
    "onUpdate:open": _cache[14] || (_cache[14] = $event => _ctx.videoDialogVisible = $event),
    closable: false,
    width: "800px",
    zIndex: 1001,
    centered: true,
    ref: "userDialog"
  }, {
    title: _withCtx(() => [_createVNode(_component_a_divider, {
      orientation: "left",
      orientationMargin: "0",
      class: "ex-dialog-title"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityDetail.videoPublish")), 1)]),
      _: 1
    })]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_160, [_createVNode(_component_a_divider, {
      style: {
        "margin": "10px 30px 10px 0px",
        "min-width": "0px"
      }
    }), _createVNode(_component_a_button, {
      class: "sts-button default",
      key: "back",
      onClick: _ctx.pubTaskCancel
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userManage.cancel")), 1)]),
      _: 1
    }, 8, ["onClick"]), _withDirectives(_createVNode(_component_a_button, {
      class: "sts-button green",
      key: "submit",
      type: "primary",
      onClick: _ctx.pubTaskOk
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("userManage.confirm")), 1)]),
      _: 1
    }, 8, ["onClick"]), [[_vShow, _ctx.activity.videoTaskInfo.length === 0]]), _withDirectives(_createVNode(_component_a_button, {
      class: "sts-button green",
      key: "submit",
      type: "primary",
      onClick: _ctx.editTaskOk
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('activityDetail.confirmEdit')), 1)]),
      _: 1
    }, 8, ["onClick"]), [[_vShow, _ctx.activity.videoTaskInfo.length != 0]])])]),
    default: _withCtx(() => [_createVNode(_component_a_spin, {
      tip: "Loading...",
      spinning: _ctx.spinLoading
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_150, [_createElementVNode("div", _hoisted_151, [_createElementVNode("span", _hoisted_152, _toDisplayString(_ctx.$t("activityDetail.activityName")), 1), _createTextVNode(), _createVNode(_component_a_input, {
        value: _ctx.activity.videoData.activityName,
        "onUpdate:value": _cache[11] || (_cache[11] = $event => _ctx.activity.videoData.activityName = $event),
        style: {
          "height": "50px",
          "width": "250px"
        },
        disabled: ""
      }, null, 8, ["value"]), _createElementVNode("span", _hoisted_153, _toDisplayString(_ctx.$t("activityDetail.activityTime")), 1), _createTextVNode(), _createVNode(_component_a_input, {
        value: _ctx.activity.videoData.activityTime,
        "onUpdate:value": _cache[12] || (_cache[12] = $event => _ctx.activity.videoData.activityTime = $event),
        style: {
          "height": "50px",
          "width": "250px"
        },
        disabled: ""
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_154, [_createElementVNode("span", _hoisted_155, _toDisplayString(_ctx.$t("activityDetail.taskInfo")), 1), _createVNode(_component_a_button, {
        class: "sts-button-circle-icon default",
        style: {
          "width": "80px",
          "height": "25px"
        },
        color: "black",
        onClick: _ctx.addTask
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.addNew")), 1)]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_a_divider)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity.videoData.videoUrl, (x, index) => {
        return _openBlock(), _createElementBlock("div", _hoisted_156, [_createElementVNode("span", _hoisted_157, _toDisplayString(_ctx.$t('activityDetail.videoLink') + (index + 1)), 1), _createTextVNode(), _createVNode(_component_a_input, {
          value: _ctx.activity.videoData.videoUrl[index],
          "onUpdate:value": $event => _ctx.activity.videoData.videoUrl[index] = $event,
          style: {
            "height": "50px",
            "width": "500px"
          }
        }, null, 8, ["value", "onUpdate:value"]), index !== 0 ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          danger: "",
          class: "sts-button-circle-icon",
          style: {
            "width": "80px",
            "height": "25px",
            "margin-left": "27px",
            "line-height": "14px"
          },
          color: "black",
          onClick: $event => _ctx.deleteTask(index)
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.delete")), 1)]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]);
      }), 256)), _createElementVNode("div", _hoisted_158, [_createElementVNode("span", _hoisted_159, _toDisplayString(_ctx.$t('activityDetail.remark')) + " 　", 1), _createTextVNode(), _createVNode(_component_a_textarea, {
        value: _ctx.activity.videoData.note,
        "onUpdate:value": _cache[13] || (_cache[13] = $event => _ctx.activity.videoData.note = $event),
        style: {
          "width": "620px"
        },
        rows: 4
      }, null, 8, ["value"])])])]),
      _: 1
    }, 8, ["spinning"])]),
    _: 1
  }, 8, ["open"])], 64);
}